import React from 'react';
import styled from 'styled-components';
import Icon from './icons/index';
const ProjectContainer = styled.div`
  display: flex;

  margin: 2rem auto;
`;
const IconWrapper = styled.div`
  width: 70px;
  height: auto;

  svg {
    fill: var(--color-primary);
  }
  @media (max-width: 768px) {
    height: 40px;
    width: 40px;
  }
`;

const ProjectInfoWrapper = styled.div`
  width: 100%;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const ProjectTitle = styled.h1`
  color: var(--color-tertiary);
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;
const ProjectLink = styled.a`
  color: var(--color-primary);
  &:hover {
    background-color: var(--color-primary);
    color: var(--color-background);
  }
`;

const ProjectInfo = styled.p`
  margin: 1rem 0;
`;
const TechWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
`;
const TechUsed = styled.ul`
  font-style: italic;
  margin: 0.3rem;
`;

export default function Project({ title, link, linktext, info, tech }) {
  return (
    <ProjectContainer>
      <IconWrapper>
        <Icon iconName="dotcorner" />
      </IconWrapper>
      <ProjectInfoWrapper>
        <ProjectTitle>{title}</ProjectTitle>
        <ProjectLink target="_blank" href={link}>
          {linktext}
        </ProjectLink>
        <ProjectInfo>{info}</ProjectInfo>
        <TechWrapper>
          {tech.map((e, idx) => (
            <TechUsed key={idx}>#{e}</TechUsed>
          ))}
        </TechWrapper>
      </ProjectInfoWrapper>
    </ProjectContainer>
  );
}
